import { defineComponent, computed, toRefs, ref, reactive, provide, resolveComponent, openBlock, createElementBlock, normalizeClass, renderSlot, createBlock, withCtx, toDisplayString, createCommentVNode } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import { DIRECTIONS, MODES, LABEL_POSITIONS } from "./constants.js";
import { timelineInjectionKey } from "./context.js";
import _TimelineItem from "./item.js";
import Spin from "../spin/index.js";
import _export_sfc from "../_virtual/plugin-vue_export-helper";
const _sfc_main = defineComponent({
  name: "Timeline",
  components: {
    Item: _TimelineItem,
    Spin
  },
  props: {
    reverse: {
      type: Boolean
    },
    direction: {
      type: String,
      validator: (value) => {
        return DIRECTIONS.includes(value);
      },
      default: "vertical"
    },
    mode: {
      type: String,
      validator: (value) => {
        return MODES.includes(value);
      },
      default: "left"
    },
    pending: {
      type: Boolean
    },
    labelPosition: {
      type: String,
      validator: (value) => {
        return LABEL_POSITIONS.includes(value);
      },
      default: "same"
    }
  },
  setup(props, { slots }) {
    const prefixCls = getPrefixCls("timeline");
    const hasPending = computed(() => {
      return props.pending || slots.pending;
    });
    const {
      reverse: reverseRef,
      direction: directionRef,
      labelPosition: labelPositionRef,
      mode: modeRef
    } = toRefs(props);
    const itemsRef = ref([]);
    function addItem(item) {
      itemsRef.value.push(item);
    }
    function removeItem(uid) {
      const index = itemsRef.value.findIndex((item) => item.uid === uid);
      if (index !== -1) {
        itemsRef.value.splice(index, 1);
      }
    }
    const timelineContext = reactive({
      addItem,
      removeItem,
      items: itemsRef.value,
      direction: directionRef,
      reverse: reverseRef,
      labelPosition: labelPositionRef,
      mode: modeRef
    });
    provide(timelineInjectionKey, timelineContext);
    const cls = computed(() => {
      return [
        prefixCls,
        `${prefixCls}-${props.mode}`,
        `${prefixCls}-direction-${props.direction}`,
        {
          [`${prefixCls}-is-reverse`]: props.reverse
        }
      ];
    });
    return {
      prefixCls,
      hasPending,
      cls
    };
  }
});
const _hoisted_1 = { key: 0 };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_spin = resolveComponent("spin");
  const _component_Item = resolveComponent("Item");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.cls)
  }, [
    renderSlot(_ctx.$slots, "default"),
    _ctx.hasPending ? (openBlock(), createBlock(_component_Item, {
      key: 0,
      "line-type": "dashed"
    }, {
      dot: withCtx(() => [
        _ctx.$slots.dot ? renderSlot(_ctx.$slots, "dot", { key: 0 }) : (openBlock(), createBlock(_component_spin, {
          key: 1,
          size: 12
        }))
      ]),
      default: withCtx(() => [
        _ctx.pending !== true ? (openBlock(), createElementBlock("div", _hoisted_1, toDisplayString(_ctx.pending), 1)) : createCommentVNode("v-if", true)
      ]),
      _: 3
    })) : createCommentVNode("v-if", true)
  ], 2);
}
var _Timeline = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { _Timeline as default };
